export default {
    CURRENCY_SYMBOL: 'beneficiary.currency-symbol',
    DETAILS: 'beneficiary.details.contract-termination',
    DUE_DATE: 'beneficiary.due-date',
    MONTHLY_FEE_CONTEXT_MENU_PREFIX: 'beneficiary.monthly-fee-context-menu-item',
    MONTHLY_FEE_STATUS: 'beneficiary.monthly-fee-status',
    PROTOCOL: 'beneficiary.protocol.contract-termination',
    REQUEST_DATE: 'beneficiary.request-date.contract-termination',
    VIEW: 'beneficiary.view',
};
export const EXPRESSIONS = {
    CANCEL: 'patient.cancel',
    CONFIRM: 'patient.button.confirm',
    PAYMENT: 'patient.online-payment.pay',
    RESCHEDULE: 'patient.reschedule',
    RESCHEDULE_MORE: 'patient.reschedule-more-items',
    STEPS_CONCLUDED: 'patient.steps-concluded',
    TASKS_CONCLUDED: 'patient.tasks-concluded',
};
//# sourceMappingURL=expression.js.map